export const getInteractions = (state) => {
  return state.interactions;
};
